import {Text, Link} from "@gs-ux-uitoolkit-react/text";
import {Form, FormFeedback, FormControl} from "@gs-ux-uitoolkit-react/form";
import {Input} from "@gs-ux-uitoolkit-react/input";
import {Button} from "@gs-ux-uitoolkit-react/button";
import React, {useState, useEffect} from "react";
import {useFormik} from "formik";
import {useSignInContext} from "../context/SignInContextProvider";
import {LoadingIcon} from "@gs-ux-uitoolkit-react/loading";
import {Checkbox} from '@gs-ux-uitoolkit-react/checkbox';
import {UsernameForm} from "./UsernameForm";
import {PasswordForm} from "./PasswordForm";

interface FormValue {
    username: string;
    password: string;
    rememberMe: boolean;
    sessionId: string;
}

export function UsernamePasswordForm() {

    const [ip, setIp] = useState('');
    const {signInAttempt, submitCredentials, submitSsoCode} = useSignInContext();
    const [busy, setBusy] = useState(false);
    const savedRememberMe = localStorage.getItem('rememberMe') === 'true';
    const [username, setUsername] = useState<string | null>(null);
    const [isInboundSso, setIsInboundSso] = useState(false);
    // @ts-ignore
    const sessionId = window.vgsSessionId;

    const initialValues = {
        username: '',
        password: '',
        rememberMe: savedRememberMe,
        // @ts-ignore
        sessionId: window.vgsSessionId,
    };

    const disabled = busy || signInAttempt?.rememberMeTokenValid == true;

    const formik = useFormik<FormValue>({
        initialValues,
        onSubmit: async (values, {setValues}) => {
            setBusy(true);
            try {
                values.username = values.username.trim().replace(/[&\/\\#+()$~%'":*?<>{}]/g, '');
                await submitCredentials(values.username, values.password, values.rememberMe, values.sessionId, ip);
                setValues(initialValues);
                localStorage.setItem('rememberMe', values.rememberMe.toString());
            } finally {
                setBusy(false);
            }
        }
    });

    useEffect(() => {
        fetch('/sign-in/ip').then(resp => resp.text())
            .then(data => { setIp(data) })
            .catch(error => console.error(error));
    }, []);

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const ssoCode = urlParams.get('ssoCode');
        const loginId = urlParams.get('loginId');
        const clientId = urlParams.get('clientId');
        if (ssoCode && loginId && clientId) {
            setIsInboundSso(true);
            const ssoCodeVal = urlParams.get('ssoCode') || '';
            const loginIdVal = urlParams.get('loginId') || '';
            const clientIdVal = urlParams.get('clientId') || '';
            const redirectUri = urlParams.get('redirectUri') || '';
            submitSsoCode(loginIdVal, ssoCodeVal, clientIdVal, sessionId, ip, redirectUri);
        }
    }, []);

    if (isInboundSso) {
        return <div>Performing SSO</div>;
    }

    // Split username/password into separate pages.
    if (!username) {
        return (
            <UsernameForm
                onContinue={(u) => setUsername(u)}
                disabled={disabled}
            />
        );
    }

    return (
        <PasswordForm
            username={username}
            onSubmit={async (password, rememberMe) => {
                await submitCredentials(username, password, rememberMe, sessionId, ip);
                localStorage.setItem('rememberMe', rememberMe.toString());
            }}
            onBack={() => setUsername(null)}
            disabled={disabled}
        />
    );
}